import { useEffect, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useWebSocket } from '../contexts/WebSocketContext';

export function useWebSocketRoom(roomId, messageHandler = null) {
    const websocketState = useSelector(state => state.websocket);
    const webSocket = useWebSocket();

    const isConnected = roomId && websocketState.connections[roomId];
    const connectionStatus = roomId ? websocketState.connectionStatus[roomId] : null;
    const messages = roomId ? websocketState.messages[roomId] || [] : [];
    const error = roomId ? websocketState.errors[roomId] : null;

    // 연결 설정
    useEffect(() => {
        if (roomId) {
            webSocket.connect(roomId);
        }
    }, [roomId, webSocket]);

    // 메시지 핸들러 등록
    useEffect(() => {
        if (roomId && messageHandler) {
            webSocket.registerMessageHandler(roomId, messageHandler);

            // 컴포넌트 언마운트 시 핸들러 제거
            return () => {
                webSocket.unregisterMessageHandler(roomId);
            };
        }
    }, [roomId, messageHandler, webSocket]);

    // 메시지 전송 함수 (중복 방지 포함)
    const sendMessage = useCallback((message) => {
        if (!roomId) return false;
        return webSocket.sendMessage(roomId, message);
    }, [roomId, webSocket]);

    return {
        isConnected,
        connectionStatus,
        messages,
        error,
        sendMessage
    };
}